module.exports = __webpack_public_path__ + "static/media/mine_c.7480014e.tif";